import React from 'react';
import { Outlet } from 'react-router-dom';
import { XlabsConfiguratorProvider } from '../../context/XlabsConfiguratorContext';

/** Pathless layout — keeps Locate ↔ Design session alive across routes. */
export default function XlabsConfiguratorLayout() {
  return (
    <XlabsConfiguratorProvider>
      <Outlet />
    </XlabsConfiguratorProvider>
  );
}
